module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "rateassist-basic-details-tab-content"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "basic-details-service-contract"
    }
  }, [_vm._v("Service Contract")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.basicDetails.serviceContract),
      expression: "basicDetails.serviceContract"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "basic-details-service-contract"
    },
    domProps: {
      "value": (_vm.basicDetails.serviceContract)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.basicDetails, "serviceContract", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "basic-details-description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.basicDetails.description),
      expression: "basicDetails.description"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5",
      "id": "basic-details-description"
    },
    domProps: {
      "value": (_vm.basicDetails.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.basicDetails, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "basic-details-notes"
    }
  }, [_vm._v("Notes")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.basicDetails.notes),
      expression: "basicDetails.notes"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5",
      "id": "basic-details-notes"
    },
    domProps: {
      "value": (_vm.basicDetails.notes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.basicDetails, "notes", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "date-from"
    }
  }, [_vm._v("Effective From")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.basicDetails.effectiveFrom),
      expression: "basicDetails.effectiveFrom"
    }],
    staticClass: "mai-date",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.basicDetails.effectiveFrom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.basicDetails, "effectiveFrom", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "date-from"
    }
  }, [_vm._v("Effective To")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.basicDetails.effectiveTo),
      expression: "basicDetails.effectiveTo"
    }],
    staticClass: "mai-date",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.basicDetails.effectiveTo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.basicDetails, "effectiveTo", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "basic-details-ratePer"
    }
  }, [_vm._v("Rates Per")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.basicDetails.ratesPer),
      expression: "basicDetails.ratesPer"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "basic-details-ratePer"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.basicDetails, "ratesPer", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.ratesPer), function(option) {
    return _c('option', {
      domProps: {
        "value": option.id
      }
    }, [_vm._v(_vm._s(option.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modeShouldShow),
      expression: "modeShouldShow"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "basic-details-mode"
    }
  }, [_vm._v("Mode")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.basicDetails.mode),
      expression: "basicDetails.mode"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "basic-details-mode"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.basicDetails, "mode", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.modes), function(option) {
    return _c('option', {
      domProps: {
        "value": option.id
      }
    }, [_vm._v(_vm._s(option.name))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "basic-details-density"
    }
  }, [_vm._v("Density")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.basicDetails.density),
      expression: "basicDetails.density"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "0.01",
      "id": "basic-details-density"
    },
    domProps: {
      "value": (_vm.basicDetails.density)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.basicDetails, "density", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "basic-details-density-type"
    }
  }, [_vm._v("Minimum Density Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.basicDetails.densityType),
      expression: "basicDetails.densityType"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "basic-details-density-type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.basicDetails, "densityType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.densities), function(option) {
    return _c('option', {
      domProps: {
        "value": option.id
      }
    }, [_vm._v(_vm._s(option.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "basic-details-sc"
    }
  }, [_vm._v("Service Class")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.basicDetails.serviceClass),
      expression: "basicDetails.serviceClass"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "basic-details-sc"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.basicDetails, "serviceClass", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.serviceTypes), function(option) {
    return _c('option', {
      domProps: {
        "value": option.id
      }
    }, [_vm._v(_vm._s(option.name))])
  })], 2)])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.containerTypeShouldShow),
      expression: "containerTypeShouldShow"
    }]
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "basic-details-container-type"
    }
  }, [_vm._v("Container Types")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.containerType),
      expression: "containerType"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "basic-details-container-type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.containerType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.containers), function(option) {
    return _c('option', {
      domProps: {
        "value": option
      }
    }, [_vm._v(_vm._s(option.name))])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon",
    on: {
      "click": _vm.addContainerType
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])]), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.basicDetails.containerTypeSelections), function(ct, i) {
    return _c('li', {
      staticClass: "list-group-item"
    }, [_c('div', {
      staticClass: "clearfix"
    }, [_vm._v("\n              " + _vm._s(ct.dataOption) + "\n              "), _c('span', {
      staticClass: "pull-right"
    }, [_c('div', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.remove('containerTypeSelections', i)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.woodLooseShouldShow),
      expression: "woodLooseShouldShow"
    }]
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "basic-details-wood-loose"
    }
  }, [_vm._v("Wood / Loose")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.woodLoose),
      expression: "woodLoose"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "basic-details-wood-loose"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.woodLoose = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.woodLooses), function(option) {
    return _c('option', {
      domProps: {
        "value": option
      }
    }, [_vm._v(_vm._s(option.name))])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon",
    on: {
      "click": _vm.addWoodLoose
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])]), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.basicDetails.woodLooseSelections), function(wl, i) {
    return _c('li', {
      staticClass: "list-group-item"
    }, [_c('div', {
      staticClass: "clearfix"
    }, [_vm._v("\n              " + _vm._s(wl.dataOption) + "\n              "), _c('span', {
      staticClass: "pull-right"
    }, [_c('div', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.remove('woodLooseSelections', i)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])])])
  }), 0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('blockquote', [_vm._v("\n        Details\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fb50b2c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/rateassist/components/BasicDetails.vue
// module id = 2160
// module chunks = 1